import Axios, { Response } from '../utils/Axios';

export type DeliveryOrderStatusParams = {
  order_status: number;
  order_id: string;
  device_uuid: string;
  order_seq: number;
};

const DeliveryController = {
  updateOrderStatus: async (params: DeliveryOrderStatusParams): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/order/updateDeliveryOrderStatus`;
      const response: any = await Axios.post(sUrl, params);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  getDeliveryPoint: async (uuid: string): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/order/getDeliveryPoint/${uuid}`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },

  setDeliveryPoint: async (uuid: string, phone_number: string, marketing: boolean): Promise<Response> => {
    try {
      let oParams = {
        device_uuid: uuid,
        phone_number: phone_number,
        markering: marketing
      }
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/order/setDeliveryPoint`;
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  }
};

export default DeliveryController;
